<template>
  <div class="Chauffage">
    <Back />

    <ProductIntro
      title="Chauffage"
      image="/images/main/chauffage.jpg"
      icon1="certificate"
      text1="Contrats d'entretien"
      icon2="autorenew"
      text2="Remplacement de chaudière"
      icon3="wrench"
      text3="Dépannage de chaudière"
    />

    <section class="section">
      <div class="container">
        <ProductParagraph
          title="Nous vous proposons l’entretien annuel de votre chaudière"
          text="
          Parce qu’une chaudière mal entretenue représente un risque pour votre santé et celle de votre famille, nous réalisons chaque année son entretien.
          Vous ferez ainsi des économies sur le long terme en décelant précocement les anomalies et surtout, vous éviterez des pannes plus importantes.
          Nous vous proposons 3 types de contrats d’entretien annuels pour votre chaudière avec de nombreux avantages."
          conclusion="Optez pour la tranquillité !"
        />
        <hr />
        <h3 class="subtitle has-text-centered">
          <b>Faites entretenir votre chaudière par Happy Chauffe & Co.</b>
        </h3>
        <div class="pricing-table">
          <div class="pricing-plan is-primary">
            <div class="plan-header">
              Happy
              <b>Eco</b>
              <br />
            </div>
            <div class="plan-price">
              <span class="is-small">A partir de</span>
              <br />
              <span class="plan-price-amount">
                90
                <span class="plan-price-currency">€</span>
              </span>HT/an
            </div>
            <div class="plan-items">
              <div class="plan-item">
                Forfait annuel comprennant l'entretien
                <br />de votre chaudière et le déplacement.
              </div>
              <div class="plan-item">
                <i class="mdi mdi-plus-circle icon-fix has-text-primary"></i>&nbsp;1 dépannage inclus
              </div>
              <div class="plan-item">-</div>
            </div>
          </div>
          <div class="pricing-plan is-info">
            <div class="plan-header">
              Happy
              <b>Confort</b>
            </div>
            <div class="plan-price">
              <span class="is-small">A partir de</span>
              <br />
              <span class="plan-price-amount">
                134
                <span class="plan-price-currency">€</span>
              </span>HT/an
            </div>
            <div class="plan-items">
              <div class="plan-item">
                Forfait annuel comprennant l'entretien
                <br />de votre chaudière et le déplacement.
              </div>
              <div class="plan-item">
                <i class="mdi mdi-all-inclusive icon-fix has-text-info"></i>&nbsp;Dépannage illimité
              </div>
              <div class="plan-item">-</div>
            </div>
          </div>
          <div class="pricing-plan is-danger">
            <div class="plan-header">
              Happy
              <b>Confort+</b>
            </div>
            <div class="plan-price">
              <span class="is-small">A partir de</span>
              <br />
              <span class="plan-price-amount">
                170
                <span class="plan-price-currency">€</span>
              </span>HT/an
            </div>
            <div class="plan-items">
              <div class="plan-item">
                Forfait annuel comprennant l'entretien
                <br />de votre chaudière et le déplacement.
              </div>
              <div class="plan-item">
                <i class="mdi mdi-all-inclusive has-text-danger icon-fix"></i>&nbsp;Dépannage illimité
              </div>
              <div class="plan-item">
                <i class="mdi mdi-plus-box has-text-danger icon-fix"></i>&nbsp;1 détartrage inclus
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <Card
        title="Nous dépannons rapidement votre chaudière"
        text="
        Nos sommes habilités pour le dépannage et le remplacement de votre chaudière gaz.
				Nos techniciens sont qualifiés et formés régulièrement.
        Nous bénéficions des labels <b>RGE</b>, <b>Qualibat</b>, <b>PG</b> et <b>PMG</b> et sommes couverts par l’assurance <b>GARANTIE DÉCENNALE</b>.
				Nous travaillons en partenariat avec les plus grandes marques, vous trouverez forcement la chaudière qui vous convient !
        "
        conclusion="Pour une solution chauffage adaptée à votre habitation !"
        image="/images/secondary/chauffage.jpg"
      />

      <br />
      <br />

      <div class="container">
        <ProductParagraph
          title="Nous remplaçons votre chaudière et assurons sa mise en service"
          text="Et oui, nous avons tout tenté, mais votre chaudière a rendu son dernier souffle « de gaz ».
          Il est temps de la remplacer, nos techniciens se chargerons de vous installer
          votre nouvelle chaudière, plus sûr, plus innovante et moins énergivore que l’ancienne. Vous gagnez en sérénité pour de nombreuses années !"
          conclusion="Pensez au contrat d’entretien !"
        />
      </div>
    </section>
  </div>
</template>

<script>
// CSS Extension
import "bulma-pricingtable/dist/css/bulma-pricingtable.min.css";

// Components
import ProductIntro from "@/components/ProductIntro";
import ProductParagraph from "@/components/ProductParagraph";
import Card from "@/components/Card";
import Back from "@/components/Back";

export default {
  name: "Chauffage",
  components: {
    ProductIntro,
    ProductParagraph,
    Card,
    Back
  }
};
</script>